var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCondolenceLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 30,
    viewBox: "0 0 151 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.142 24.761C52.8058 24.761 50.0908 22.0429 50.0908 18.7028C50.0908 15.3626 52.8058 12.6445 56.142 12.6445C59.4782 12.6445 62.1931 15.3626 62.1931 18.7028C62.1931 22.0429 59.4782 24.761 56.142 24.761ZM56.142 15.6523C54.4625 15.6523 53.0951 17.0213 53.0951 18.7028C53.0951 20.3842 54.4625 21.7532 56.142 21.7532C57.8214 21.7532 59.1888 20.3842 59.1888 18.7028C59.1888 17.0213 57.8214 15.6523 56.142 15.6523Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5154 22.9494H86.9678V19.9416H91.5154C93.1948 19.9416 94.5622 18.5726 94.5622 16.8912V14.1504H97.5665V16.8912C97.5665 20.2313 94.8516 22.9494 91.5154 22.9494Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0043 20.1344H0C0 16.7943 2.71493 14.0762 6.05115 14.0762V17.084C4.37169 17.084 3.0043 18.453 3.0043 20.1344Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.498 30.0017H6.05115C2.71493 30.0017 0 27.2836 0 23.9435V20.1348H3.0043V23.9435C3.0043 25.6249 4.37169 26.9939 6.05115 26.9939H11.498C13.1775 26.9939 14.5449 25.6249 14.5449 23.9435V21.2907H17.5492V23.9435C17.5492 27.2836 14.8343 30.0017 11.498 30.0017Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5166 30.0018V26.9939C42.1961 26.9939 43.5635 25.6249 43.5635 23.9435V14.1504H46.5678V23.9464C46.5678 27.2836 43.8528 30.0018 40.5166 30.0018Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4219 30.0018V26.9939C84.1013 26.9939 85.4687 25.6249 85.4687 23.9435V14.1504H88.473V23.9464C88.473 27.2836 85.7581 30.0018 82.4219 30.0018Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8822 21.5442C66.546 21.5442 63.8311 18.8261 63.8311 15.486C63.8311 12.1458 66.546 9.42773 69.8822 9.42773C73.2184 9.42773 75.9333 12.1458 75.9333 15.486C75.9333 18.8261 73.2184 21.5442 69.8822 21.5442ZM69.8822 12.4384C68.2027 12.4384 66.8354 13.8074 66.8354 15.4888C66.8354 17.1702 68.2027 18.5392 69.8822 18.5392C71.5617 18.5392 72.9291 17.1702 72.9291 15.4888C72.9291 13.8045 71.5617 12.4384 69.8822 12.4384Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.123 22.7928C75.4762 22.7928 73.74 22.6451 70.2392 21.4664L71.1981 18.6176C74.5173 19.7367 75.9187 19.7878 76.1145 19.7878L76.2081 19.7736L76.2365 19.7849C77.9159 19.7849 79.2833 18.416 79.2833 16.7345C79.2833 15.2377 78.2166 13.9738 76.7471 13.7267C76.4946 13.6841 66.4293 11.7386 64.415 11.3494L64.9853 8.39844C68.2874 9.03749 76.9287 10.7075 77.2549 10.7644C80.1685 11.2557 82.2876 13.7665 82.2876 16.7374C82.2876 20.0633 79.5982 22.77 76.2847 22.7956C76.2422 22.7928 76.1883 22.7928 76.123 22.7928Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3057 22.9489H59.9766V19.9411H66.3057C68.2462 19.9411 69.154 19.8757 69.7157 19.248L71.9512 21.2561C70.4363 22.9489 68.337 22.9489 66.3057 22.9489Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M23.809 21.5442C20.4727 21.5442 17.7578 18.8261 17.7578 15.486C17.7578 12.1458 20.4727 9.42773 23.809 9.42773C27.1452 9.42773 29.8601 12.1458 29.8601 15.486C29.8601 18.8261 27.1452 21.5442 23.809 21.5442ZM23.809 12.4384C22.1295 12.4384 20.7621 13.8074 20.7621 15.4888C20.7621 17.1702 22.1295 18.5392 23.809 18.5392C25.4884 18.5392 26.8558 17.1702 26.8558 15.4888C26.8558 13.8045 25.4884 12.4384 23.809 12.4384Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M30.041 22.7928C29.3942 22.7928 27.658 22.6451 24.1572 21.4664L25.1161 18.6176C28.4353 19.7367 29.8367 19.7878 30.0325 19.7878L30.1261 19.7736L30.1544 19.7849C31.8339 19.7849 33.2013 18.416 33.2013 16.7345C33.2013 15.2377 32.1346 13.9738 30.6651 13.7267C30.4126 13.6841 20.3472 11.7386 18.333 11.3494L18.9032 8.39844C22.2054 9.03749 30.8467 10.7075 31.1729 10.7644C34.0864 11.2557 36.2056 13.7665 36.2056 16.7374C36.2056 20.0633 33.5162 22.77 30.2027 22.7956C30.1601 22.7928 30.1062 22.7928 30.041 22.7928Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2319 22.9489H9.22461V19.9411H20.229C22.1695 19.9411 23.0773 19.8757 23.639 19.248L25.8745 21.2561C24.3596 22.9489 22.2603 22.9489 20.2319 22.9489Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8706 19.9414H45.9883V22.9492H52.8706V19.9414Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2035 8.05273H38.1992V25.2333H41.2035V8.05273Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M103.246 8.05273H100.241V25.2333H103.246V8.05273Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8618 28.0814C93.8598 28.0814 94.6689 27.2713 94.6689 26.2721C94.6689 25.2729 93.8598 24.4629 92.8618 24.4629C91.8638 24.4629 91.0547 25.2729 91.0547 26.2721C91.0547 27.2713 91.8638 28.0814 92.8618 28.0814Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M143.288 25.1975H134.548V21.5961C135.929 21.5961 137.263 21.1928 138.4 20.4316C140.335 19.1365 141.49 16.975 141.49 14.646C141.49 13.811 141.342 12.993 141.056 12.2176L140.242 10.025L142.568 9.79775C142.809 9.77503 143.044 9.76367 143.288 9.76367C147.541 9.76367 150.999 13.2231 150.999 17.4778C150.999 21.7353 147.541 25.1975 143.288 25.1975ZM142.48 21.5961H143.288C145.558 21.5961 147.402 19.7471 147.402 17.4778C147.402 15.8389 146.437 14.4217 145.05 13.7599C145.076 14.0553 145.087 14.3507 145.087 14.646C145.087 17.2392 144.142 19.696 142.48 21.5961Z",
    fill: "url(#paint0_linear_14670_87510)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M134.551 25.2847H126.04C121.742 25.2847 118.244 21.7827 118.244 17.4769C118.244 13.4836 121.254 10.1832 125.121 9.72592C126.936 6.25515 130.579 4 134.551 4C138.968 4 142.971 6.78343 144.511 10.9273C144.954 12.1174 145.178 13.3671 145.178 14.6424C145.178 18.204 143.41 21.5129 140.452 23.4954C138.707 24.6684 136.664 25.2847 134.551 25.2847ZM126.04 13.4523C123.824 13.4523 122.02 15.2587 122.02 17.4769C122.02 19.698 123.824 21.5072 126.04 21.5072H134.551C135.915 21.5072 137.229 21.1096 138.352 20.3569C140.261 19.0788 141.402 16.943 141.402 14.6452C141.402 13.8215 141.257 13.0149 140.974 12.248C139.981 9.57538 137.399 7.78036 134.551 7.78036C131.708 7.78036 129.127 9.5697 128.131 12.2338L127.651 13.5176L126.284 13.4608C126.205 13.4551 126.122 13.4523 126.04 13.4523Z",
    fill: "url(#paint1_linear_14670_87510)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.644 10.2143C117.736 10.7759 118.043 8.89037 111.231 6.91717C116.066 1.81672 119.834 5.28488 123.644 1.20396V0.992387C123.644 0.444299 124.005 0 124.452 0C124.898 0 125.26 0.444299 125.26 0.992387L125.209 13C125.209 12.6419 125.21 12.6228 125.209 13H124.452H124.044H123.811C123.811 13 123.753 13 124.044 13H123.644V10.2143Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14670_87510",
    x1: 134.548,
    y1: 17.48,
    x2: 150.998,
    y2: 17.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3439
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5772
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7137
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9335,
    stopColor: "#6E7191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E7191"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14670_87510",
    x1: 118.246,
    y1: 14.6435,
    x2: 145.179,
    y2: 14.6435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1428
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2541
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4476
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7831
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9132,
    stopColor: "#4E4B66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77787B",
    stopOpacity: 0.08
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondolenceLogo);
export default __webpack_public_path__ + "static/media/condolenceLogo.e5c6b498beb02be0115b77acb983813d.svg";
export { ForwardRef as ReactComponent };